import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  name: 'LineChart',
}
